import * as React from 'react';
import { connect } from 'react-redux';

import PageHeading from 'components/page/page-heading/PageHeading';

import CampaignPurchaseOrder from 'modules/campaigns/components/purchase-order/CampaignPurchaseOrder';
import CcmCampaignPaymentsInvoice from './invoice/CcmCampaignPaymentsInvoice';
import CcmCampaignPaymentsPayouts from './payouts/CcmCampaignPaymentsPayouts';

import { fetchSubcampaigns } from 'modules/campaigns/reducers/campaignSubcampaigns';
import { fetchPaymentInfo, flush } from './redux/actions';

import { isCcmModerator } from 'utils/account';
import { __t, applyTranslations } from 'utils/language';

import './ccm-campaign-payments.scss';

applyTranslations(require('./ccm-campaign-payments.i18n.json'));

interface OwnProps {
  campaignId: number
}

interface StateProps {
  isModeratorView: boolean
}

interface DispatchProps {
  dispatchFetchSubcampaigns: (campaignId: number) => Promise<void>,
  dispatchFetchPaymentInfo: (campaignId: number) => Promise<void>,
  dispatchFlush: () => void
}

type Props = StateProps & DispatchProps & OwnProps;

const CcmCampaignPayments = ({
  isModeratorView,
  campaignId,
  dispatchFetchSubcampaigns,
  dispatchFetchPaymentInfo,
  dispatchFlush
}: Props) => {
  React.useEffect(() => {
    dispatchFetchSubcampaigns(campaignId);
    dispatchFetchPaymentInfo(campaignId);

    return () => dispatchFlush();
  }, []);

  return (
    <div>
      <CampaignPurchaseOrder
        campaignId={campaignId}
      />
      <div>
        <PageHeading
          heading={__t('ccm_campaign_payments.brand.header')}
          message={__t('ccm_campaign_payments.brand.message')}
          color="light"
          size="h1"
          customClass="ccm_campaign_payments__section-heading"
        />
        <div>
          <CcmCampaignPaymentsInvoice />
        </div>
      </div>
      {isModeratorView ? (
        <div>
          <PageHeading
            heading={__t('ccm_campaign_payments.creators.header')}
            message={__t('ccm_campaign_payments.creators.message')}
            color="light"
            size="h1"
            customClass="ccm_campaign_payments__section-heading"
          />
          <div>
            <CcmCampaignPaymentsPayouts />
          </div>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = ({ account }): StateProps => ({
  isModeratorView: isCcmModerator(account.roles ?? [])
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchSubcampaigns: id => dispatch(fetchSubcampaigns(id, { showLoadingComponent: false })),
  dispatchFetchPaymentInfo: id => dispatch(fetchPaymentInfo(id)),
  dispatchFlush: () => dispatch(flush())
});

export default connect(mapStateToProps, mapDispatchToProps)(CcmCampaignPayments);
